import axios from '@/libs/api.request'
var qs = require('qs');

export const login = ({ userName, password }) => {
    let data = {
        username: userName,
        password: password

    }
    data = qs.stringify(data)
    return axios.request({
        url: 'login-exit/login',
        data,
        method: 'post'
    })
}

export const getUserInfo = (token) => {
    var data = {
        'access': ['senateManagement', 'schoolManagement', 'systemManagement', 'adminList'],
    }
    return data;
}

export const logout = (token) => {
    return axios.request({
        url: 'logout',
        method: 'post'
    })
}